module.exports = {
  breweryAPIKey: "key=3bad94fa310bbfd8ac6ed2cdcfd07d13",
};
